import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { TEAM_OPENED, TEAM_MEMBER_SEARCHED, TEAM_MEMBER_OPENED, TEAM_MEMBER_INVITED, TEAM_MEMBER_DELETED, } from './TeamSegmentEvents';
export class TeamSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackOpened(payload, success) {
        this.trackEvent(TEAM_OPENED, payload, success);
    }
    trackMemberSearched(payload, success) {
        this.trackEvent(TEAM_MEMBER_SEARCHED, payload, success);
    }
    trackMemberOpened(payload, success) {
        this.trackEvent(TEAM_MEMBER_OPENED, payload, success);
    }
    trackMemberInvited(payload, success) {
        this.trackEvent(TEAM_MEMBER_INVITED, payload, success);
    }
    trackMemeberDeleted(payload, success) {
        this.trackEvent(TEAM_MEMBER_DELETED, payload, success);
    }
    trackEvent(event, payload, success) {
        this.SegmentService.createBotTrack(event, this.application, { ...payload, Status: this.eventStatus(success) });
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
TeamSegmentService.$inject = ['SegmentService'];
